export const CONFIG = {
  PLATFORM: process.env.REACT_APP_PLATFORM || 'web'
} as const;